import {KeyEvent} from "../../../infrastructure/models/analytics/key-event";
import {APP} from "../../../core/app/consts";

export class WebsiteModuleBrowserSearchKeyEvent extends KeyEvent {
  screen: APP.ANALYTICS.SOURCES;

  constructor(screen: APP.ANALYTICS.SOURCES) {
    super('', 'key', 'ctrl-f');

    this.screen = screen;
  }

  get properties(): Object {
    const properties = super.properties;

    properties.screen = this.screen;

    return properties;
  }

  get isPopulated(): Boolean {
    let isPopulated = super.isPopulated;

    isPopulated &= Boolean(this.screen);

    return isPopulated;
  }
}
